module.exports = __webpack_public_path__ + "img/sended.f6f4597e.png";